import React, { Component, useContext, useEffect, useRef, useState } from 'react'
import { withRoutePane } from '@/components/hoc/routePane'
import { RProps } from '@/config/props';
import { drawing } from '@/interface/constage';
import { Button, Modal, Spin, message, Input } from 'antd';
import './drawing-list.less';
import { ViewChange } from './view-change';
import { AmbientLight, Box3, BoxGeometry, BufferGeometry, Camera, DirectionalLight, Color, DoubleSide, Float32BufferAttribute, LessDepth, Mesh, MeshBasicMaterial, MeshPhongMaterial, MeshStandardMaterial, Object3D, OrthographicCamera, PerspectiveCamera, Scene, WebGLRenderer, SphereGeometry, MathUtils } from "three";
import { addMonitorObjectPrimitive, findMonitorObjectPrimitiveByProjectId, findPrimitivesInProject, deleteMonitorObjectPrimitive, updateMonitorObjectPrimitive, generateBallPrimitive, movePrimitive, deletePrimitive, changePrimitiveColor } from '@/config/api/primitives';
import { MonitorObjectPrimitive, Primitive } from '@/interface/primitive';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import classNames from "classnames";
import { ReactComponent as InfoSvg } from './icons/info.svg';
import { ReactComponent as InfoBlueSvg } from './icons/info-blue.svg';
import { ReactComponent as EditSvg } from './icons/edit-white.svg';
import ConstructOverview from './construct-overview';
import { EdgeHighlightRenderer } from "./EdgeHighlightRenderer"
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { ProjectContext } from '@/config/context'
import { mobject } from '@/interface/mobject';
import { queryMobjects } from '@/config/api/mobject';
import { MobjectBaseType } from '@/utils/type';
import { ReactComponent as PanSvg } from './icons/pan.svg';
import { ReactComponent as RotateSvg } from './icons/rotate.svg';
import { ReactComponent as PanBlueSvg } from './icons/pan-blue.svg';
import { ReactComponent as RotateBlueSvg } from './icons/rotate-blue.svg';

const buildingOpacity = 0.2

export const SHOW_TYPE = {
    MONITOR: 0,
    SHOW: 1
}

export const VIEW_STATE = {
    NONE: - 1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
}
export enum CAMERA_TYPE {
    Orthographic,
    Perspective
}
interface IProps extends RProps {

}
interface IState {
    drawings: drawing[]
    isEdit: boolean
    currentDrawing: drawing
    onLinkState: boolean
}

interface MObjectPrimitive extends mobject {
    project_id?: number,//关联信息属于哪个项目
    primitive_uuid?: string,//关联的图元的UUID
}

const projectUuid = "projectUuid-wx"
const modelUuid = "modelUuid"

export const DrawingListPage: React.FC<IState> = (props) => {
    const projectId = useContext(ProjectContext);//当前项目id
    const viewportId = "viewportId";
    const cameraType = CAMERA_TYPE.Perspective
    const cameraEdge = 30

    // const stats = useRef<Stats>();
    const camera = useRef<Camera>(null)
    const scene = useRef<Scene>(null)
    const renderer = useRef<WebGLRenderer>(null)
    const viewChange = useRef<ViewChange>(null)
    const edgeRenderer = useRef<EdgeHighlightRenderer>(null)
    // const controls = useRef<OrbitControls>(null)

    const [showInfo, setShowInfo] = useState<boolean>(false); // 展示信息
    const [activeEntityUuid, setActiveEntityUuid] = useState<string>("")
    const activeEntity = useRef<Object3D>(null)
    // 添加选中球体坐标状态
    const [selectedSphereCoords, setSelectedSphereCoords] = useState({ x: 0, y: 0, z: 0 });
    // 添加移动距离状态
    const [moveDistance, setMoveDistance] = useState<number>(1000);

    const [isPopupVisible, setIsPopupVisible] = useState(false);//控制是否显示绑定弹窗
    const [isSphereModalVisible, setSphereModalVisible] = useState<boolean>(false); // 控制球体参数输入框
    const [isColorModalVisible, setIsColorModalVisible] = useState<boolean>(false); // 控制颜色选择Modal
    const [selectedColor, setSelectedColor] = useState<string>(null); // 存储选中的颜色
    const [sphereParams, setSphereParams] = useState({
        cx: 0,
        cy: 0,
        cz: 0
    });
    const [mobjects, setMobjects] = useState<MObjectPrimitive[]>([]);    // 使用状态来存储从后端获取的 mobjects 列表（并补充了图元关联表的相关字段）
    const [selectedMobjectId, setSelectedMobjectId] = useState<number | null>(null); // 存储当前选中的 mobject 的 ID
    const [overviewUpdateTrigger, setOverviewUpdateTrigger] = useState(0);    // 存储修改更新状态信号
    const [loading, setLoading] = useState<boolean>(false)
    // 添加存储球体中心点坐标的Map
    const sphereCoordsMap = useRef<Map<string, { x: number, y: number, z: number }>>(new Map());

    const [editStates, setEditStates] = useState<number>(0); // 编辑状态 0：默认 1：平移 2：旋转
    const [showType, setShowType] = useState<number>(SHOW_TYPE.SHOW) // 展示类别

    const mobjectsRef = useRef<MObjectPrimitive[]>([])

    const monitorObjectRef = useRef<Object3D[]>([])
    const showObjectRef = useRef<Object3D[]>([])

    const isInit = useRef<boolean>(false)

    const [selectedEntityUuid, setSelectedEntityUuid] = useState<string | null>(null); // 只保存球体uuid

    // 预定义的六种颜色
    const predefinedColors = [
        { name: '深红', value: '#B22222' },
        { name: '深蓝', value: '#000080' },
        { name: '黑色', value: '#000000' },
        { name: '深橙', value: '#CC5500' },
        { name: '深紫', value: '#4B0082' },
        { name: '深绿', value: '#006400' },
        { name: '翠绿', value: '#B2F55F' }
    ];

    // 在其他状态变量后添加一个确认删除弹窗的状态
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false); // 控制删除确认Modal

    useEffect(() => {
        camera.current = createCamera(cameraEdge, cameraType);
        scene.current = initScene()
        renderer.current = createRenderer();

        // 初始化视图控制器
        viewChange.current = new ViewChange(renderer.current.domElement, camera.current, scene.current, changeSelect, resetEdit)

        edgeRenderer.current = new EdgeHighlightRenderer(renderer.current.domElement)

        // 初始化数据与旋转中心
        let allBox: Box3 = new Box3()

        generateData(allBox)
        window.addEventListener('resize', onWindowResize);

        return (() => {
            window.removeEventListener('resize', onWindowResize);
        })
    }, [])

    useEffect(() => {
        if (!(showType == SHOW_TYPE.MONITOR || showType == SHOW_TYPE.SHOW)) return
        if (!isInit.current) return
        let remvoeList = []
        let addList = []
        if (showType == SHOW_TYPE.SHOW) {
            remvoeList = monitorObjectRef.current
            addList = showObjectRef.current
        } else {
            addList = monitorObjectRef.current
            remvoeList = showObjectRef.current
        }
        // 清空场景
        for (let i = 0; i < remvoeList?.length; i++) {
            let midObj = remvoeList[i]
            if (midObj && midObj.parent) {
                midObj.parent.remove(midObj)
            }
        }
        // 添加场景
        let allBox = new Box3()
        for (let i = 0; i < addList?.length; i++) {
            scene.current.add(addList[i])
            allBox.expandByObject(addList[i]);
        }
        if (addList?.length > 0) {
            allBox.getCenter(viewChange.current.rotateCenter)
            viewChange.current?.showAllEntities(allBox)
            renderer?.current?.render(scene?.current, camera?.current)
        }


    }, [showType])

    const resetEdit = () => {
        setEditStates(0)
    }

    const onWindowResize = () => {
        const root = document.getElementById(viewportId);
        if (!root) return;
        const aspect = root.offsetWidth / root.offsetHeight;
        if (!camera.current) return
        camera.current.left = camera.current.bottom * aspect;
        camera.current.right = camera.current.top * aspect;
        camera.current.updateProjectionMatrix();
        renderer.current.setSize(root.offsetWidth, root.offsetHeight);
        renderer.current.setViewport(0, 0, root.offsetWidth, root.offsetHeight)
    }

    const generateData = (allBox: Box3) => {
        setLoading(true)
        Promise.all([
            queryMobjects({ project_id: projectId }),
            findMonitorObjectPrimitiveByProjectId(projectId)
        ]).then(([mobjectsRes, primitivesRes]) => {
            if (mobjectsRes.status === 200 && primitivesRes.status === 200) {
                const mobjectList: mobject[] = mobjectsRes.data || [];
                const monitorPrimitives: MonitorObjectPrimitive[] = primitivesRes.data || [];
                const updatedMobjects = mobjectList.map((mobject) => {
                    const matchingPrimitive = monitorPrimitives.find(
                        (primitive) => primitive.monitor_object_id === mobject.id
                    );
                    return matchingPrimitive
                        ? { ...mobject, primitive_uuid: matchingPrimitive.primitive_uuid }
                        : mobject;
                });
                setMobjects(updatedMobjects);
                mobjectsRef.current = [...updatedMobjects]
            } else {
                message.error("获取列表或关联数据失败");
            }
            return findPrimitivesInProject(projectUuid, modelUuid, 0)
        }).then(res => {
            let primitiveList: Primitive[] = res.data || []

            // 清空中心点坐标Map
            sphereCoordsMap.current.clear();

            for (let i = 0; i < primitiveList.length; i++) {
                const primitive = primitiveList[i];
                const { position, color } = primitive.properties;

                // 更严格的位置数据验证
                if (!position) {
                    continue;
                }

                if (!Array.isArray(position)) {
                    continue;
                }

                if (position.length % 3 !== 0) {
                    continue;
                }

                if (!position.every(num => typeof num === 'number' && !isNaN(num))) {
                    continue;
                }

                try {
                    // 计算球体中心点坐标并存储
                    const centerCoords = calculateSphereCenter(position);
                    sphereCoordsMap.current.set(primitive.uuid, centerCoords);

                    const geometry = new BufferGeometry();
                    const positionAttr = new Float32BufferAttribute(position, 3);
                    geometry.setAttribute("position", positionAttr);

                    // 处理颜色值
                    let colorToUse;
                    if (typeof color === 'string') {
                        if (color.startsWith('#')) {
                            colorToUse = color; // 使用原始带#的格式
                        } else if (color.match(/^[0-9A-Fa-f]{6}$/)) {
                            colorToUse = `#${color}`; // 添加#前缀
                        } else {
                            colorToUse = color; // 其他格式保持不变
                        }
                    } else {
                        colorToUse = '#ffffff'; // 默认为白色
                    }

                    const material = new MeshStandardMaterial({
                        color: colorToUse,
                        transparent: true,
                        opacity: 1
                    });

                    const mesh = new Mesh(geometry, material);
                    mesh.uuid = primitive.uuid;
                    monitorObjectRef.current.push(mesh);
                    scene.current.add(mesh);
                    // 更新包围盒
                    let midBox = new Box3().setFromBufferAttribute(positionAttr)
                    allBox.union(midBox)
                } catch (error) {
                    // 错误处理
                }
            }
            if (primitiveList?.length > 0) {
                allBox.getCenter(viewChange.current.rotateCenter)
                viewChange.current.showAllEntities(allBox)
                animate()
            }
        }).finally(() => {
            loadFbxFile()
            isInit.current = true
            setLoading(false)
        })
    }

    // 加载FBX模型
    const loadFbxFile = () => {
        const fbxLoader = new FBXLoader();
        if (!scene.current) return
        // 修改为相对路径，避免404错误
        const modelPath = '/api/static/model/model.fbx'; // 修改为正确的路径

        fbxLoader.load(
            modelPath,
            (fbx) => {
                // 用来存储所有生成的 JSONy 数据
                const model = fbx;
                // 遍历模型的材质，设置透明度
                model.traverse((child) => {
                    if (child.isMesh) {
                        if (child.material) {
                            if (Array.isArray(child.material)) {
                                // 如果材质是数组
                                child.material.forEach((mat) => {
                                    mat.transparent = true; // 开启透明
                                    // mat.opacity = buildingOpacity; // 设置透明度
                                });
                            } else {
                                // 单一材质
                                child.material.transparent = true;
                                // child.material.opacity = buildingOpacity;
                            }
                        }
                    }
                });
                // 将模型添加到场景
                model.position.set(0, 0, 0);
                scene.current.add(model);
                setLoading(false)
                renderer?.current?.render(scene?.current, camera?.current)
            },
            (progress) => {
                // 进度处理
            },
            (error) => {
                message.error(`模型加载失败: ${error.message}`);
                setLoading(false)
                animate()
            }
        );
    };

    // 打开弹窗时检查并设置是否选择了监测对象
    const openPopup = () => {
        // 如果 activeEntityUuid 有值，查找对应的 mobject 项
        const matchedObject = mobjects.find(mobject => mobject.primitive_uuid === activeEntityUuid);
        if (matchedObject) {
            // 设置 selectedMobjectId 为与 activeEntityUuid 对应的 mobject id
            setSelectedMobjectId(matchedObject.id);
        } else {
            // 如果没有匹配项，则清空 selectedMobjectId
            setSelectedMobjectId(null);
        }
        setIsPopupVisible(true); // 显示弹窗
    };

    // 判断是否可以选中，已绑定的且不是当前 activeEntityUuid 的项目不可选
    const isSelectable = (mobject) => {
        return !mobject.primitive_uuid || mobject.primitive_uuid === activeEntityUuid;
    };

    // 绑定弹窗的选择栏
    const handleRowSelect = (id: number) => {
        if (selectedMobjectId === id) {
            // 如果再次点击同一个 ID，清空选中项
            setSelectedMobjectId(null);
        } else {
            // 否则设置为新的选中项
            setSelectedMobjectId(id);
        }
    };

    // 删除绑定的监测对象
    const handleDelete = () => {
        deleteMonitorObjectPrimitive(activeEntityUuid)
            .then(res => {
                if (res.status === 200) {
                    message.success("删除成功！");
                    setIsPopupVisible(false);
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.primitive_uuid === activeEntityUuid
                                ? { ...mobject, primitive_uuid: null }
                                : mobject
                        )
                    );
                    setSelectedMobjectId(null); // 清空选中项
                    // 触发 ConstructOverview 组件重新挂载
                    setOverviewUpdateTrigger(prev => prev + 1);
                } else {
                    message.error("删除失败，请重试！");
                }
            })
            .catch(error => {
                message.error("删除失败，请重试！");
            });
    };

    // 添加监测对象的绑定
    const handleAdd = () => {
        addMonitorObjectPrimitive(projectId, selectedMobjectId, activeEntityUuid)
            .then(res => {
                if (res.status === 200) {
                    message.success("绑定成功！");
                    setIsPopupVisible(false); // 关闭弹窗
                    setSelectedMobjectId(null); // 清空选中项

                    // 更新 mobjects 中对应项的 primitive_uuid
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.id === selectedMobjectId
                                ? { ...mobject, primitive_uuid: activeEntityUuid }
                                : mobject
                        )
                    );
                    // 触发 ConstructOverview 组件重新挂载
                    setOverviewUpdateTrigger(prev => prev + 1);
                } else {
                    message.error("绑定失败，请重试！");
                }
            })
            .catch(error => {
                message.error("绑定失败，请重试！");
            });
    };

    // 更新监测对象的绑定
    const handleUpdate = () => {
        const data = {
            project_id: projectId,
            primitive_uuid: activeEntityUuid,
            monitor_object_id: selectedMobjectId
        };

        updateMonitorObjectPrimitive(activeEntityUuid, data)
            .then(res => {
                if (res.status === 200) {
                    message.success("更新成功！");
                    setIsPopupVisible(false); // 关闭弹窗
                    setSelectedMobjectId(null); // 清空选中项
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.primitive_uuid === activeEntityUuid
                                ? { ...mobject, primitive_uuid: null }
                                : mobject
                        ).map(mobject =>
                            mobject.id === selectedMobjectId
                                ? { ...mobject, primitive_uuid: activeEntityUuid }
                                : mobject
                        )
                    );
                    setSelectedMobjectId(null);
                    // 触发 ConstructOverview 组件重新挂载
                    setOverviewUpdateTrigger(prev => prev + 1);
                } else {
                    message.error("更新失败，请重试！");
                }
            })
            .catch(error => {
                message.error("更新失败，请重试！");
            });
    };

    // 弹窗点击确认的函数
    const handleConfirmBinding = () => {
        // 判断当前图元是否已经绑定过
        const matchedObject = mobjects.find(mobject => mobject.primitive_uuid === activeEntityUuid);
        //删除：判断条件之前绑定过，当前没有选择绑定对象
        if (!selectedMobjectId && matchedObject) {
            // 仅取消绑定
            handleDelete();
            return;
        }
        //更新：判断条件已经绑定对象，但是选择绑定对象与之前不同
        if (matchedObject && selectedMobjectId) {
            // 进行更新绑定
            handleUpdate();
            //新增：判定条件之前没有绑定但是现在选择了绑定对象
        } else if (selectedMobjectId) {
            // 新增绑定
            handleAdd();
        } else {
            message.warning("请选择一个监测对象！");
        }
    };

    // 弹窗点击"取消"时的函数
    const handleCancel = () => {
        setSelectedMobjectId(null);
        setIsPopupVisible(false);
    };

    const oldColor = useRef<Color>(null)
    const oldSelect = useRef<Object3D>(null)
    //点击图元的回调函数
    const changeSelect = (entities: Object3D[]) => {
        // 判断是否选中绑定元素
        let bindEntities = entities.filter(item =>
            mobjectsRef.current.find(mItem => mItem.primitive_uuid == item.uuid) &&
            item.uuid != oldSelect.current?.uuid
        )

        let entity
        if (bindEntities?.length > 0) {
            entity = bindEntities[bindEntities.length - 1]
        }
        else if (entities?.length > 0) {
            entity = entities[0]
        }

        if (oldSelect.current) {
            oldSelect.current.material.color = oldColor.current
        }
        setActiveEntityUuid(entity?.uuid)
        activeEntity.current = entity
        setSelectedEntityUuid(entity?.uuid || null); // 只保存uuid

        // 从存储的Map中获取坐标，如果没有则计算
        if (entity) {
            const uuid = entity.uuid;
            let coords = sphereCoordsMap.current.get(uuid);

            if (!coords) {
                // 如果Map中没有存储坐标，则计算并存储
                coords = calculateSphereCoords(entity);
                sphereCoordsMap.current.set(uuid, coords);
            }

            // 更新UI显示 - 使用message显示坐标
            setSelectedSphereCoords(coords);
            // 移除message弹窗

            oldColor.current = entity.material.color.clone()
            oldSelect.current = entity
            entity.material.color = new Color(0x00ff00)
        } else {
            // 如果 entity 为空，清空 activeEntityUuid 并隐藏信息
            setActiveEntityUuid("");
            oldColor.current = null
            oldSelect.current = null
        }
    }

    // 计算单个球体的中心点坐标
    const calculateSphereCoords = (entity: Object3D): { x: number, y: number, z: number } => {
        if (!entity || !entity.geometry) {
            return { x: 0, y: 0, z: 0 };
        }

        // 获取几何体的position属性
        const geometry = entity.geometry as BufferGeometry;
        const positionAttribute = geometry.getAttribute('position');

        if (!positionAttribute) {
            return { x: 0, y: 0, z: 0 };
        }

        // 将TypedArray转换为普通数组
        const positionArray: number[] = [];
        for (let i = 0; i < positionAttribute.array.length; i++) {
            positionArray.push(positionAttribute.array[i]);
        }

        // 计算中心点
        return calculateSphereCenter(positionArray);
    };

    // 监听 activeEntityUuid 的变化，当它更新时检查是否应显示 ConstructOverview
    useEffect(() => {
        if (!(activeEntityUuid?.length > 0)) {
            setShowInfo(false);
        } else {
            // 检查 activeEntityUuid 是否与 mobjects 中的某个 primitive_uuid 匹配
            const matchingObject = mobjects.find(mobject => mobject.primitive_uuid === activeEntityUuid);
            if (matchingObject) {
                setShowInfo(true);
            } else {
                setShowInfo(false);
            }
        }
    }, [activeEntityUuid]);     // 依赖 activeEntityUuid

    const createCamera = (s = 30, cameraType = CAMERA_TYPE.Perspective) => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        const aspect = root.offsetWidth / root.offsetHeight;
        if (cameraType === CAMERA_TYPE.Orthographic) {
            const camera = new OrthographicCamera(-s * aspect, s * aspect, s, -s, 0.1, 1e7);
            camera.position.set(-1e7 / 2, -1e7 / 2, 1e7 / 2)
            camera.up.set(0, 0, 1)
            camera.lookAt(0, 0, 0)
            return camera;
        } else if (cameraType === CAMERA_TYPE.Perspective) {
            const fov = 75;
            const camera = new PerspectiveCamera(fov, aspect, 0.1, 1e7);
            camera.position.set(0, 0, 300000)
            camera.lookAt(0, 0, 0)
            return camera;
        }
        return null;
    }

    const createRenderer = () => {
        const root = document.getElementById(viewportId);
        if (!root) return null;
        root.oncontextmenu = (e) => {
            e.preventDefault();
        }
        const renderer = new WebGLRenderer({
            antialias: true,
            logarithmicDepthBuffer: true
        });
        // renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(root.offsetWidth, root.offsetHeight);
        renderer.setClearColor('#f5f5f5', 1.0);
        renderer.autoClear = false;
        renderer.setClearColor('#ffffff', 0);
        renderer.domElement.style.background = '#ffffff';

        renderer.setAnimationLoop(animate);
        root.appendChild(renderer.domElement);
        // renderer.domElement.setAttribute('tabindex', '1');
        // renderer.domElement.style.outline = '0px';
        return renderer;
    }

    const initScene = () => {
        let scene = new Scene();

        // 在初始化部分添加光源
        // 添加光照
        const ambientLight = new AmbientLight(0xffffff, 1);
        scene.add(ambientLight);

        const directionalLight = new DirectionalLight(0xffffff, 1);
        directionalLight.position.set(1, 0, 0).normalize();
        directionalLight.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight);
        const directionalLight1 = new DirectionalLight(0xffffff, 1);
        directionalLight1.position.set(-1, 0, 0).normalize();
        directionalLight1.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight1);
        const directionalLight2 = new DirectionalLight(0xffffff, 1);
        directionalLight2.position.set(0, 1, 0).normalize();
        directionalLight2.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight2);
        const directionalLight3 = new DirectionalLight(0xffffff, 1);
        directionalLight3.position.set(0, -1, 0).normalize();
        // directionalLight3.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight3);
        const directionalLight4 = new DirectionalLight(0xffffff, 1);
        directionalLight4.position.set(-1, -1, -1).normalize();
        directionalLight4.castShadow = true; // 使光源投射阴影
        scene.add(directionalLight4);

        return scene
    }

    const animate = () => {
        renderer.current.render(scene.current, camera.current)
        // controls.current.update();
        // requestAnimationFrame(animate);
        // edgeRenderer.current.render(renderer.current, camera.current, scene.current, cameraEdge, aspect, activeEntity.current)
    }

    useEffect(() => {
        if (!viewChange.current) return
        viewChange.current.changeViewState(editStates)
    }, [editStates])

    // 预留：新建球体时与后端交互
    const createSphereApi = async (sphereData) => {
        // TODO: 调用后端接口创建球体
        // sphereData 包含新球体的相关信息
    };

    // 修改handleCreateSphere函数
    const handleCreateSphere = async () => {
        if (!scene.current) {
            message.error('场景未初始化');
            return;
        }

        setLoading(true);
        try {
            const res = await generateBallPrimitive(projectUuid, modelUuid, sphereParams);
            if (res.status !== 200 || !res.data) {
                message.error('新建球体失败');
                setLoading(false);
                return;
            }

            // 获取新创建的球体数据
            const newPrimitive = res.data;

            if (newPrimitive && newPrimitive.properties) {
                const { position, color } = newPrimitive.properties;

                // 验证position数据
                if (!position || !Array.isArray(position) || position.length % 3 !== 0 ||
                    !position.every(num => typeof num === 'number' && !isNaN(num))) {
                    message.error('新建球体数据无效');
                    setLoading(false);
                    return;
                }

                // 计算并存储新球体的中心点坐标
                const centerCoords = calculateSphereCenter(position);
                sphereCoordsMap.current.set(newPrimitive.uuid, centerCoords);

                // 创建新球体的几何体和材质
                const geometry = new BufferGeometry();
                const positionAttr = new Float32BufferAttribute(position, 3);
                geometry.setAttribute("position", positionAttr);

                // 处理颜色值
                let colorToUse;
                if (typeof color === 'string') {
                    if (color.startsWith('#')) {
                        colorToUse = color; // 使用原始带#的格式
                    } else if (color.match(/^[0-9A-Fa-f]{6}$/)) {
                        colorToUse = `#${color}`; // 添加#前缀
                    } else {
                        colorToUse = color; // 其他格式保持不变
                    }
                } else {
                    colorToUse = '#ffffff'; // 默认为白色
                }

                const material = new MeshStandardMaterial({
                    color: colorToUse,
                    transparent: true,
                    opacity: 1
                });

                // 创建新的网格对象并添加到场景和引用数组
                const mesh = new Mesh(geometry, material);
                mesh.uuid = newPrimitive.uuid;
                monitorObjectRef.current.push(mesh);
                scene.current.add(mesh);

                // 取消之前选中球体的高亮
                if (oldSelect.current) {
                    oldSelect.current.material.color = oldColor.current;
                }

                // 高亮显示新创建的球体
                setActiveEntityUuid(newPrimitive.uuid);
                setSelectedEntityUuid(newPrimitive.uuid);
                activeEntity.current = mesh;
                oldColor.current = material.color.clone();
                oldSelect.current = mesh;
                mesh.material.color = new Color(0x00ff00);

                // 更新坐标显示
                setSelectedSphereCoords(centerCoords);

                // 更新场景
                renderer.current?.render(scene.current, camera.current);
                message.success('新建球体成功');
            } else {
                message.error('新建球体返回数据无效');
            }

            setSphereModalVisible(false);
        } catch (e) {
            message.error('新建球体请求异常');
        } finally {
            setLoading(false);
        }
    };

    // 修改颜色变换的API调用
    const changeSphereColorApi = async (uuid: string, color: string) => {
        try {
            // const response = await fetch(`/api/projects/${projectUuid}/blueprintUuid/${modelUuid}/changeColor`, {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify({
            //         uuid,
            //         color
            //     })
            // });
            // return await response.json();
            let res = (await changePrimitiveColor(projectUuid, modelUuid, { uuid: uuid, color: color }))
            return res
        } catch (error) {
            throw error;
        }
    };

    // 修改handleChangeColor函数
    const handleChangeColor = async () => {
        if (!scene.current || !selectedEntityUuid || !selectedColor) {
            message.warning('请先选择球体和颜色');
            return;
        }

        setLoading(true);
        try {
            const res = await changeSphereColorApi(selectedEntityUuid, selectedColor);

            if (res?.data) {
                // 不刷新整个场景，只修改当前选中对象的颜色
                const obj = scene.current.getObjectByProperty('uuid', selectedEntityUuid);
                if (obj && obj.material) {
                    // 确保颜色值正确处理
                    let colorToUse = selectedColor;
                    if (selectedColor && !selectedColor.startsWith('#')) {
                        colorToUse = `#${selectedColor}`;
                    }

                    obj.material.color = new Color(colorToUse);

                    // 更新oldColor引用
                    if (obj === oldSelect.current) {
                        oldColor.current = obj.material.color.clone();
                    }

                    renderer.current?.render(scene.current, camera.current);
                    message.success('颜色修改成功');
                }
            } else {
                message.error('颜色修改失败');
            }
        } catch (e) {
            message.error('颜色修改请求异常');
        } finally {
            setLoading(false);
            setIsColorModalVisible(false);
            setSelectedColor(null);
        }
    };

    // 修改handleSphereParamChange函数
    const handleSphereParamChange = (param: string, value: string) => {
        const numValue = Number(value);
        if (!isNaN(numValue)) {
            setSphereParams(prev => ({
                ...prev,
                [param]: numValue
            }));
        }
    };

    // 修改"新建球体"按钮的点击处理
    const handleCreateSphereButtonClick = () => {
        setSphereModalVisible(true);
        setSphereParams({
            cx: 0,
            cy: 0,
            cz: 0
        });
    };

    // 修改移动球体的API函数，适配后端API参数
    const moveSphereApi = async (uuid: string, axis: 'x' | 'y' | 'z', delta: number) => {
        try {
            // 准备deltaX, deltaY, deltaZ参数
            const params = {
                uuid,
                deltaX: axis === 'x' ? delta : 0,
                deltaY: axis === 'y' ? delta : 0,
                deltaZ: axis === 'z' ? delta : 0
            };

            // 使用primitives.ts中定义的movePrimitive函数
            const response = await movePrimitive(projectUuid, modelUuid, params);

            return response;
        } catch (error) {
            throw error;
        }
    };

    // 修改方向按钮的点击处理函数，使用moveDistance
    const handleDirectionClick = async (direction: 'x+' | 'x-' | 'y+' | 'y-' | 'z+' | 'z-') => {
        if (!selectedEntityUuid) {
            message.warning('请先选择一个球体');
            return;
        }

        setLoading(true);
        try {
            // 解析方向和轴
            const axis = direction.charAt(0) as 'x' | 'y' | 'z';
            const isPositive = direction.charAt(1) === '+';
            const delta = isPositive ? moveDistance : -moveDistance; // 使用设置的移动距离

            // 方向映射
            const directionMap = {
                'x+': '右',
                'x-': '左',
                'y+': '上',
                'y-': '下',
                'z+': '前',
                'z-': '后'
            };

            const res = await moveSphereApi(selectedEntityUuid, axis, delta);

            if (res?.status === 200 && res?.data) {
                // 更新单个球体而不刷新整个场景
                updateSingleSphere(res.data);
                message.success(`${directionMap[direction]}方向移动成功`);
            } else {
                message.error(`移动失败: ${res?.data?.message || '未知错误'}`);
            }
        } catch (error) {
            message.error(`移动失败: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    // 添加更新单个球体的函数
    const updateSingleSphere = (primitive: Primitive) => {
        try {
            if (!primitive || !primitive.uuid || !primitive.properties) {
                return;
            }

            const { position, color } = primitive.properties;

            // 验证position数据
            if (!position || !Array.isArray(position) || position.length % 3 !== 0 ||
                !position.every(num => typeof num === 'number' && !isNaN(num))) {
                return;
            }

            // 找到场景中的球体
            const existingSphere = scene.current.getObjectByProperty('uuid', primitive.uuid);
            if (existingSphere) {
                // 从场景中移除现有球体
                scene.current.remove(existingSphere);

                // 从引用数组中移除
                monitorObjectRef.current = monitorObjectRef.current.filter(obj => obj.uuid !== primitive.uuid);
            }

            // 计算并更新中心点坐标
            const centerCoords = calculateSphereCenter(position);
            sphereCoordsMap.current.set(primitive.uuid, centerCoords);

            // 创建新的几何体和材质
            const geometry = new BufferGeometry();
            const positionAttr = new Float32BufferAttribute(position, 3);
            geometry.setAttribute("position", positionAttr);

            // 处理颜色值
            let colorToUse;
            if (typeof color === 'string') {
                if (color.startsWith('#')) {
                    colorToUse = color; // 使用原始带#的格式
                } else if (color.match(/^[0-9A-Fa-f]{6}$/)) {
                    colorToUse = `#${color}`; // 添加#前缀
                } else {
                    colorToUse = color; // 其他格式保持不变
                }
            } else {
                colorToUse = '#ffffff'; // 默认为白色
            }

            const material = new MeshStandardMaterial({
                color: colorToUse,
                transparent: true,
                opacity: 1
            });

            // 创建新的网格对象
            const mesh = new Mesh(geometry, material);
            mesh.uuid = primitive.uuid;

            // 添加到场景和引用数组
            monitorObjectRef.current.push(mesh);
            scene.current.add(mesh);

            // 如果是当前选中的球体，应用高亮效果并更新坐标
            if (primitive.uuid === selectedEntityUuid) {
                if (oldSelect.current && oldSelect.current !== mesh) {
                    oldSelect.current.material.color = oldColor.current;
                }
                oldColor.current = material.color.clone();
                oldSelect.current = mesh;
                mesh.material.color = new Color(0x00ff00);
                activeEntity.current = mesh;

                // 计算并更新坐标显示
                const centerCoords = calculateSphereCenter(position);
                setSelectedSphereCoords(centerCoords);
            }

            // 重新渲染场景
            renderer.current?.render(scene.current, camera.current);
        } catch (error) {
            // 错误处理
        }
    };

    // 添加坐标转换工具函数 - 从position计算球体中心点坐标
    const calculateSphereCenter = (positions: number[]): { x: number, y: number, z: number } => {
        if (!positions || positions.length < 3) {
            return { x: 0, y: 0, z: 0 };
        }

        // 计算所有顶点的平均值，得到球体中心
        // 注意：此方法在球体是完美对称的情况下才准确
        // 与后端生成的球体匹配，因为后端是以中心点为基准生成的球体
        let sumX = 0, sumY = 0, sumZ = 0;
        let count = 0;

        for (let i = 0; i < positions.length; i += 3) {
            sumX += positions[i];
            sumY += positions[i + 1];
            sumZ += positions[i + 2];
            count++;
        }

        // 返回球体中心点坐标 - 与后端生成时的cx,cy,cz对应
        return {
            x: count > 0 ? Math.round(sumX / count * 100) / 100 : 0, // 保留两位小数，避免精度问题
            y: count > 0 ? Math.round(sumY / count * 100) / 100 : 0,
            z: count > 0 ? Math.round(sumZ / count * 100) / 100 : 0
        };
    };

    // 这个函数与后端同名函数逻辑完全一致，确保前后端计算方式相同
    const sphericalToCartesian = (cx: number, cy: number, cz: number, r: number, theta: number, phi: number): number[] => {
        const x = cx + r * Math.sin(theta) * Math.cos(phi);
        const y = cy + r * Math.cos(theta);
        const z = cz + r * Math.sin(theta) * Math.sin(phi);
        return [x, y, z];
    };

    // 添加三角面的辅助函数 - 与后端同名函数逻辑完全一致
    const addTriangle = (positions: number[], p1: number[], p2: number[], p3: number[]) => {
        positions.push(...p1, ...p2, ...p3);
    };

    // 从球体中心和半径生成position数组 - 与后端同名函数逻辑完全一致
    const generateSpherePositions = (cx: number, cy: number, cz: number, radius: number,
        widthSegments: number, heightSegments: number): number[] => {
        // 参数验证
        if (widthSegments < 3 || heightSegments < 2) {
            return [];
        }

        if (radius < 10) {
            return [];
        }

        const positions: number[] = [];

        // 生成球体顶点 - 算法与后端完全相同
        for (let y = 0; y < heightSegments; y++) {
            const theta1 = (y / heightSegments) * Math.PI;
            const theta2 = ((y + 1) / heightSegments) * Math.PI;

            for (let x = 0; x < widthSegments; x++) {
                const phi1 = (x / widthSegments) * 2 * Math.PI;
                const phi2 = ((x + 1) / widthSegments) * 2 * Math.PI;

                const p1 = sphericalToCartesian(cx, cy, cz, radius, theta1, phi1);
                const p2 = sphericalToCartesian(cx, cy, cz, radius, theta2, phi1);
                const p3 = sphericalToCartesian(cx, cy, cz, radius, theta2, phi2);
                const p4 = sphericalToCartesian(cx, cy, cz, radius, theta1, phi2);

                if (y === 0) {
                    // 顶部只需要一个三角面
                    addTriangle(positions, p1, p2, p3);
                } else if (y === heightSegments - 1) {
                    // 底部只需要一个三角面
                    addTriangle(positions, p1, p2, p4);
                } else {
                    // 中间区域两个三角面
                    addTriangle(positions, p1, p2, p4);
                    addTriangle(positions, p2, p3, p4);
                }
            }
        }

        return positions;
    };

    // 处理移动距离输入变化
    const handleMoveDistanceChange = (value: number | null) => {
        if (value !== null && !isNaN(value)) {
            setMoveDistance(value);
        }
    };

    // 删除球体的API函数
    const deletePrimitiveApi = async (uuid: string) => {
        try {
            return await deletePrimitive(projectUuid, modelUuid, uuid);
        } catch (error) {
            throw error;
        }
    };

    // 处理删除按钮点击事件
    const handleDeleteButtonClick = () => {
        if (!selectedEntityUuid) {
            message.warning('请先选择一个球体');
            return;
        }

        setIsDeleteModalVisible(true);
    };

    // 处理确认删除
    const handleConfirmDelete = async () => {
        if (!selectedEntityUuid) {
            return;
        }

        setLoading(true);
        try {
            // 检查是否绑定了监测对象
            const matchedObject = mobjects.find(mobject => mobject.primitive_uuid === selectedEntityUuid);

            // 如果绑定了监测对象，先解除绑定
            if (matchedObject) {
                await deleteMonitorObjectPrimitive(selectedEntityUuid);
            }

            // 删除球体
            const res = await deletePrimitiveApi(selectedEntityUuid);

            if (res && (res.status === 200 || res.data)) {
                // 从场景中移除球体
                const existingSphere = scene.current.getObjectByProperty('uuid', selectedEntityUuid);
                if (existingSphere) {
                    scene.current.remove(existingSphere);
                    monitorObjectRef.current = monitorObjectRef.current.filter(obj => obj.uuid !== selectedEntityUuid);
                }

                // 清空选中状态
                setSelectedEntityUuid(null);
                setActiveEntityUuid("");
                oldColor.current = null;
                oldSelect.current = null;

                // 更新页面
                renderer.current?.render(scene.current, camera.current);
                message.success('球体删除成功');

                // 如果有绑定的监测对象，更新mobjects状态
                if (matchedObject) {
                    setMobjects(prevMobjects =>
                        prevMobjects.map(mobject =>
                            mobject.id === matchedObject.id
                                ? { ...mobject, primitive_uuid: null }
                                : mobject
                        )
                    );
                    // 触发ConstructOverview组件重新挂载
                    setOverviewUpdateTrigger(prev => prev + 1);
                }
            } else {
                message.error('球体删除失败');
            }
        } catch (error) {
            message.error('删除请求异常');
        } finally {
            setLoading(false);
            setIsDeleteModalVisible(false);
        }
    };

    return (
        <Spin
            tip={`加载中`}
            spinning={loading}
            wrapperClassName='drawing-spin-main'
        >
            <div className={classNames("draw-main", {
                "show-panel": showInfo,
                "draw-main-pan": editStates === 1,
                "draw-main-rotate": editStates === 2
            })}>
                <div className={classNames("icon-group", { "shifted": showInfo })}>
                    <div className={classNames({
                        "icon": true,
                        "selected": showInfo
                    })} onClick={() => setShowInfo(!showInfo)}>
                        {showInfo ? <InfoSvg /> : <InfoBlueSvg />}
                    </div>
                    <div className={classNames({
                        "icon": true,
                        "selected": editStates == 1,
                    })} onClick={() => setEditStates(editStates == 1 ? 0 : 1)}>
                        {editStates == 1 ? <PanSvg /> : <PanBlueSvg />}
                    </div>
                    <div className={classNames({
                        "icon": true,
                        "selected": editStates == 2,
                    })} onClick={() => setEditStates(editStates == 2 ? 0 : 2)}>
                        {editStates == 2 ? <RotateSvg /> : <RotateBlueSvg />}
                    </div>
                    <div className={classNames({
                        "icon": true
                    })} onClick={() => { if (activeEntityUuid != null) { openPopup() } }}>
                        <EditSvg />
                    </div>
                </div>
                <div
                    id={viewportId}
                    className="viewport">
                </div>
                {showInfo && <ConstructOverview
                    key={overviewUpdateTrigger}  // 强制组件重新挂载
                    projectId={Number(projectId)}
                    activeEntityUuid={activeEntityUuid} />}

                <Modal
                    title="绑定监测对象"
                    visible={isPopupVisible}
                    onCancel={() => setIsPopupVisible(false)}
                    footer={[
                        <Button key="close" onClick={handleCancel}>
                            取消
                        </Button>,
                        <Button key="confirm" type="primary" onClick={handleConfirmBinding} disabled={!selectedMobjectId && !mobjects.find(m => m.primitive_uuid === activeEntityUuid)}>
                            确定
                        </Button>
                    ]}
                >
                    <div className="table-container">
                        <div className="table-header">
                            <div className="radio-placeholder"></div>
                            <span>监测对象名称</span>
                            <span>监测类型</span>
                        </div>
                        <div className="table-body">
                            {mobjects.map((mobject) => {
                                const isDisabled = !isSelectable(mobject); // 判断该项是否不可选
                                return (
                                    <div
                                        key={mobject.id}
                                        className={`table-row ${selectedMobjectId === mobject.id ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                                        onClick={() => !isDisabled && handleRowSelect(mobject.id)} // 只有可选项才能点击
                                    >
                                        <input
                                            type="radio"
                                            name="tableRow"
                                            checked={selectedMobjectId === mobject.id}
                                            onChange={() => handleRowSelect(mobject.id)}
                                            disabled={isDisabled} // 禁用已绑定的且不是当前 activeEntityUuid 的项目
                                        />
                                        <span>{mobject.name}</span>
                                        <span>{MobjectBaseType[mobject.type]?.alias || '未知类型'}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Modal>
            </div>
            {/* 球体参数输入Modal */}
            <Modal
                title="设置球体参数"
                visible={isSphereModalVisible}
                onCancel={() => {
                    setSphereModalVisible(false);
                    setSphereParams({
                        cx: 0,
                        cy: 0,
                        cz: 0
                    });
                }}
                onOk={handleCreateSphere}
                okText="确定"
                cancelText="取消"
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div>
                        <span style={{ display: 'inline-block', width: '120px' }}>X坐标：</span>
                        <Input
                            type="number"
                            value={sphereParams.cx}
                            onChange={(e) => handleSphereParamChange('cx', e.target.value)}
                            style={{ width: '200px' }}
                        />
                    </div>
                    <div>
                        <span style={{ display: 'inline-block', width: '120px' }}>Y坐标：</span>
                        <Input
                            type="number"
                            value={sphereParams.cy}
                            onChange={(e) => handleSphereParamChange('cy', e.target.value)}
                            style={{ width: '200px' }}
                        />
                    </div>
                    <div>
                        <span style={{ display: 'inline-block', width: '120px' }}>Z坐标：</span>
                        <Input
                            type="number"
                            value={sphereParams.cz}
                            onChange={(e) => handleSphereParamChange('cz', e.target.value)}
                            style={{ width: '200px' }}
                        />
                    </div>
                </div>
            </Modal>

            {/* 颜色选择Modal */}
            <Modal
                title="选择颜色"
                visible={isColorModalVisible}
                onCancel={() => {
                    setIsColorModalVisible(false);
                    setSelectedColor(null);
                }}
                onOk={handleChangeColor}
                okText="确定"
                cancelText="取消"
                okButtonProps={{ disabled: !selectedColor }}
            >
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '15px',
                    justifyContent: 'center',
                    padding: '10px'
                }}>
                    {predefinedColors.map((color) => (
                        <div
                            key={color.value}
                            onClick={() => setSelectedColor(color.value)}
                            style={{
                                height: '100px',
                                backgroundColor: color.value,
                                cursor: 'pointer',
                                border: selectedColor === color.value ? '4px solid #333' : '1px solid #ccc',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: ['#FFFF00', '#FFA500'].includes(color.value) ? '#000' : '#fff',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                boxShadow: selectedColor === color.value ? '0 0 10px rgba(0,0,0,0.3)' : 'none',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            {color.name}
                        </div>
                    ))}
                </div>
            </Modal>

            {/* 替换方向按钮组为六个方向按钮 - 美化样式 - 移至右下角 */}
            <div style={{
                position: 'fixed',
                bottom: 20,
                right: 20,
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                width: '280px',
                padding: '15px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                zIndex: 1000
            }}>
                <div style={{
                    marginBottom: '10px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: '#333'
                }}>
                    球体移动控制
                </div>

                {/* 添加移动距离输入 */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '10px'
                }}>
                    <span style={{ marginRight: '10px', whiteSpace: 'nowrap' }}>移动距离:</span>
                    <Input
                        type="number"
                        value={moveDistance}
                        onChange={(e) => handleMoveDistanceChange(Number(e.target.value))}
                        style={{ flexGrow: 1 }}
                    />
                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gridTemplateRows: 'repeat(2, 1fr)',
                    gap: '8px'
                }}>
                    {/* X轴控制 */}
                    <Button
                        type="primary"
                        onClick={() => handleDirectionClick('x-')}
                        style={{
                            backgroundColor: '#f56a00',
                            borderColor: '#f56a00',
                            height: '40px',
                            fontWeight: 'bold',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        icon={<span style={{ marginRight: '4px' }}>←</span>}
                    >
                        X-
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => handleDirectionClick('x+')}
                        style={{
                            backgroundColor: '#f56a00',
                            borderColor: '#f56a00',
                            height: '40px',
                            fontWeight: 'bold',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        icon={<span style={{ marginRight: '4px' }}>→</span>}
                    >
                        X+
                    </Button>

                    {/* Y轴控制 */}
                    <Button
                        type="primary"
                        onClick={() => handleDirectionClick('y-')}
                        style={{
                            backgroundColor: '#52c41a',
                            borderColor: '#52c41a',
                            height: '40px',
                            fontWeight: 'bold',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        icon={<span style={{ marginRight: '4px' }}>↓</span>}
                    >
                        Y-
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => handleDirectionClick('y+')}
                        style={{
                            backgroundColor: '#52c41a',
                            borderColor: '#52c41a',
                            height: '40px',
                            fontWeight: 'bold',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        icon={<span style={{ marginRight: '4px' }}>↑</span>}
                    >
                        Y+
                    </Button>

                    {/* Z轴控制 */}
                    <Button
                        type="primary"
                        onClick={() => handleDirectionClick('z-')}
                        style={{
                            backgroundColor: '#1677ff',
                            borderColor: '#1677ff',
                            height: '40px',
                            fontWeight: 'bold',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        icon={<span style={{ marginRight: '4px' }}>⬅</span>}
                    >
                        Z-
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => handleDirectionClick('z+')}
                        style={{
                            backgroundColor: '#1677ff',
                            borderColor: '#1677ff',
                            height: '40px',
                            fontWeight: 'bold',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        icon={<span style={{ marginRight: '4px' }}>➡</span>}
                    >
                        Z+
                    </Button>
                </div>
            </div>

            {/* 美化底部操作按钮 */}
            <div style={{
                position: 'fixed',
                bottom: 20,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000,
                display: 'flex',
                gap: '15px',
                alignItems: 'center'
            }}>
                {/* 坐标显示框放在新建球体按钮旁边 */}
                <div style={{
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    display: selectedEntityUuid ? 'flex' : 'none',
                    alignItems: 'center',
                    minWidth: '180px',
                    marginRight: '10px'
                }}>
                    <div>
                        <span style={{ fontWeight: 'bold' }}>{"坐标 "}</span>
                        <span style={{ marginLeft: '8px' }}>
                            X：{selectedSphereCoords.x.toFixed(2)},
                            Y：{selectedSphereCoords.y.toFixed(2)},
                            Z：{selectedSphereCoords.z.toFixed(2)}
                        </span>
                    </div>
                </div>

                <Button
                    type="primary"
                    icon={<span style={{ marginRight: '4px' }}>+</span>}
                    onClick={handleCreateSphereButtonClick}
                    style={{
                        backgroundColor: '#1890ff',
                        borderColor: '#1890ff',
                        height: '40px',
                        padding: '0 20px',
                        fontWeight: 'bold'
                    }}
                >
                    新建球体
                </Button>
                <Button
                    type="primary"
                    icon={<span style={{ marginRight: '4px' }}>🎨</span>}
                    onClick={() => {
                        if (!selectedEntityUuid) {
                            message.warning('请先选择一个球体');
                            return;
                        }
                        setIsColorModalVisible(true);
                    }}
                    style={{
                        backgroundColor: '#722ed1',
                        borderColor: '#722ed1',
                        height: '40px',
                        padding: '0 20px',
                        fontWeight: 'bold'
                    }}
                >
                    变换颜色
                </Button>
                <Button
                    type="primary"
                    danger
                    icon={<span style={{ marginRight: '4px' }}>🗑</span>}
                    onClick={handleDeleteButtonClick}
                    style={{
                        height: '40px',
                        padding: '0 20px',
                        fontWeight: 'bold'
                    }}
                >
                    删除球体
                </Button>
            </div>

            {/* 删除确认Modal */}
            <Modal
                title="确认删除"
                visible={isDeleteModalVisible}
                onCancel={() => setIsDeleteModalVisible(false)}
                onOk={handleConfirmDelete}
                okText="确认删除"
                cancelText="取消"
                okButtonProps={{ danger: true }}
            >
                <div>
                    <p>确定要删除选中的球体吗？此操作不可恢复。</p>
                    {mobjects.find(mobject => mobject.primitive_uuid === selectedEntityUuid) && (
                        <div style={{
                            padding: '10px',
                            backgroundColor: '#fffbe6',
                            border: '1px solid #ffe58f',
                            borderRadius: '4px',
                            marginTop: '10px'
                        }}>
                            <p style={{ color: '#fa8c16', fontWeight: 'bold', marginBottom: '5px' }}>⚠️ 警告</p>
                            <p>该球体已绑定监测对象，删除后将自动解除绑定。</p>
                        </div>
                    )}
                </div>
            </Modal>
        </Spin>
    );
}

export default withRoutePane(DrawingListPage, '结构模型');